<template>
  <v-card>
    <v-card-title style="text-align: left; font-weight: bold">
      Chuyển vận hành
    </v-card-title>
    <v-card-text class="d-flex flex-column align-center">
      <div class="mb-4">Vui lòng điền đầy đủ thông tin để Vận hành tiếp nhận và xử lý!</div>
      <validation-observer ref="validator" style="width: 100%">
        <validation-provider v-slot="{ errors }" class="mb-2 w-100" rules="required" name="Lý do">
          <v-select
            :items="computedChangeReason"
            placeholder="Lý do chuyển sang vận hành"
            style="width: 100%"
            persistent-placeholder
            :error-messages="errors"
            v-model="form.reasonType"
          >
            <template v-slot:label>
              Chọn lý do <span style="color: red"> *</span>
            </template>
          </v-select>
        </validation-provider>
        <template v-if="form.reasonType === CLASS_ASSIGNMENT_CHANGE_REASON.ASSIGN_LATER">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider
                class="mb-2 w-100" rules="required"
                name="Ngày hẹn"
                v-slot="{ errors }"
                v-model="form.classAssignmentAppointmentDate"
              >
                <v-text-field
                  v-model="computedAppointmentDateFormatted"
                  label="Chọn ngày hẹn"
                  placeholder="Chọn ngày"
                  persistent-placeholder
                  readonly
                  :error-messages="errors"
                  v-bind="attrs"
                  v-on="on"
                >
                  <template v-slot:label>
                    Chọn ngày hẹn <span style="color: red">*</span>
                  </template>
                </v-text-field>
              </validation-provider>
            </template>
            <v-date-picker
              v-model="form.classAssignmentAppointmentDate"
              class="appointment-date-picker"
              no-title
              locale="vi-en"
              format
              @input="menu = false"
            >
            </v-date-picker>
          </v-menu>
        </template>
        <v-text-field
          label="Note yêu cầu của phụ huynh"
          placeholder="Nhập mô tả"
          persistent-placeholder
          style="width: 100%"
          v-model="form.note"
        >
        </v-text-field>
      </validation-observer>
      <!--        <validation-observer ref="observer">-->
      <!--          -->
      <!--        </validation-observer>-->
    </v-card-text>
    <v-card-actions class="d-flex justify-center mb-4">
      <v-btn color="#ED185A" style="color: white" @click="submit">Cập nhật</v-btn>
      <v-btn color="#AEAEB2" style="color: white" @click="close">Đóng</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  CLASS_ASSIGNMENT_CHANGE_REASON_OPTION,
  CLASS_ASSIGNMENT_CHANGE_REASON,
  UPDATE_CARE_TAG, CLASS_ASSIGNMENT_1N_CHANGE_REASON_OPTION,
} from '@/modules/student_care/constant/constant';
import TutorSortClassRepository from '@/services/TutorSortClassRepository';

const ARRANGE_CLASS_TYPE = {
  ONE_ONE: 0,
  ONE_N: 1,
};

export default {
  name: 'ChangeOperatorPopup',
  props: {
    studentCareInfo: {
      type: Object,
      required: true,
    },
    studentProductId: {
      type: Number,
      required: true,
    },
    classType: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    computedChangeReason() {
      if (this.classType === ARRANGE_CLASS_TYPE.ONE_ONE) {
        return CLASS_ASSIGNMENT_CHANGE_REASON_OPTION.filter((item) => item.selectable === true);
      }
      if (this.classType === ARRANGE_CLASS_TYPE.ONE_N) {
        return CLASS_ASSIGNMENT_1N_CHANGE_REASON_OPTION;
      }
      return [];
    },
    computedAppointmentDateFormatted() {
      return this.formatDate(this.form.classAssignmentAppointmentDate);
    },
  },
  data() {
    return {
      CLASS_ASSIGNMENT_CHANGE_REASON,
      CLASS_ASSIGNMENT_CHANGE_REASON_OPTION,
      menu: false,
      form: {
        reasonType: '',
        note: '',
        classAssignmentAppointmentDate: '',
      },
    };
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.validator.validate();
      if (isValid) {
        const loading = this.$loading.show();
        this.form.studentProductId = this.studentProductId;
        const result = await TutorSortClassRepository.changeOperator(this.form);
        if (result.success) {
          const payload = {
            care_id: this.studentCareInfo.id,
            lms_core_user_id: this.studentCareInfo.lms_core_user_id,
            curriculum_id: this.studentCareInfo.curriculum_id,
            move_to: UPDATE_CARE_TAG.CHUYEN_VAN_HANH,
          };
          TutorSortClassRepository.updateCareTag(payload);
          this.$swal({
            text: 'Chuyển vận hành thành công',
            toast: true,
            icon: 'success',
            showConfirmButton: false,
            timer: 4000,
            position: 'top',
            timerProgressBar: true,
            didOpen: (toast) => {
              // eslint-disable-next-line no-param-reassign
              toast.onmouseenter = this.$swal.stopTimer;
              // eslint-disable-next-line no-param-reassign
              toast.onmouseleave = this.$swal.resumeTimer;
            },
          });
          this.$emit('finish-change-operator');
        } else {
          this.$swal({
            text: `Chuyển vận hành thất bại: ${result.errors.message}`,
            toast: true,
            icon: 'error',
            showConfirmButton: false,
            timer: 4000,
            position: 'top',
            timerProgressBar: true,
            didOpen: (toast) => {
              // eslint-disable-next-line no-param-reassign
              toast.onmouseenter = this.$swal.stopTimer;
              // eslint-disable-next-line no-param-reassign
              toast.onmouseleave = this.$swal.resumeTimer;
            },
          });
        }
        loading.hide();
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.appointment-date-picker.v-card {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
